import { hero, heroMetrics } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-4 py-12 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-14">
        <div className="flex flex-col lg:col-span-6">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="live-dot h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            {hero.tag}
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-[1.3] text-foreground-950 md:text-4xl lg:text-[3.25rem]">
            51黑料网今日黑料：
            <span className="text-primary-600">明星网红爆料吃瓜，明星黑料网红黑料一网打尽</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {hero.description}
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {hero.keywords.map((kw) => (
              <span
                key={kw}
                className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800"
              >
                {kw}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#timeline"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              {hero.primaryCta}
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#collections"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-folder-2-line"></i>
              {hero.secondaryCta}
            </a>
          </div>

          <div className="mt-10 flex flex-wrap divide-x divide-background-200">
            {heroMetrics.map((m) => (
              <div key={m.label} className="pr-6 pl-6 first:pl-0">
                <div className="font-heading text-xl font-black text-foreground-950">{m.value}</div>
                <div className="mt-1 text-xs text-foreground-500">{m.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative mx-auto max-w-[520px] lg:ml-auto lg:mr-0">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-2xl bg-background-200">
              <img
                src={hero.coverImage}
                alt="今日头条爆料封面"
                title="51黑料网 今日头条爆料 明星黑料 网红黑料"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-x-5 bottom-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50 dark:text-foreground-950">
                  <i className="ri-fire-fill"></i>
                  {hero.coverTag}
                </span>
                <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50">
                  {hero.coverTitle}
                </h2>
              </div>
            </div>

            <div className="absolute -right-3 -top-4 rounded-xl border border-background-200 bg-background-50 px-4 py-3 shadow-sm md:-right-6">
              <div className="flex items-center gap-2">
                <span className="live-dot h-2 w-2 rounded-full bg-primary-500"></span>
                <span className="text-xs text-foreground-500">实时爆料</span>
              </div>
              <div className="mt-1 font-heading text-lg font-black text-primary-600">
                {hero.liveBadge}
              </div>
            </div>

            <div className="absolute -bottom-6 -left-4 hidden h-28 w-28 overflow-hidden rounded-xl border-4 border-background-50 bg-background-200 sm:block md:-left-8 md:h-36 md:w-36">
              <img
                src={hero.subImage}
                alt="爆料现场特写配图"
                title="51黑料网 爆料现场 吃瓜"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}